import React from "react";
import type {VoidFunctionComponent} from "react";
import {usePlayingTimeDurationSwitcherLogic} from "./PlayingTimeDurationSwitcher.logic";
import {DurationSwitcher, IDurationSwitcherProps} from "../duration-switcher/DurationSwitcher";

export const PlayingTimeDurationSwitcher: VoidFunctionComponent = () => {
  const {selectedRange, changeSelectedRange} = usePlayingTimeDurationSwitcherLogic();
  return <DurationSwitcher {...{selectedRange, changeSelectedRange} as IDurationSwitcherProps} />;
}
